<div class="main-content table-page table-page--compact gestion-prospeccion-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Prospección</h1>
        <p>Controle el seguimiento de prospectos y administre sus avances comerciales desde una sola tabla.</p>
      </div>

      <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="agregarProspecto()">
        <i class="material-icons">add</i>
        <span>Alta de Prospecto</span>
      </button>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar">
        <mat-form-field appearance="outline" class="table-page__search-field">
          <mat-label>Buscar prospecto</mat-label>
          <input matInput aria-label="Buscar prospecto" type="text" maxlength="50" (keyup)="filtroBusqueda($any($event.target).value)" />
        </mat-form-field>
      </div>

      <div class="table-page__table-wrap">
        <table class="table-page__table" *ngIf="listaProspectos.length > 0; else prospeccionEmptyState">
          <thead>
            <tr>
              <th>Prospecto</th>
              <th>Fecha de inicio</th>
              <th>Estatus</th>
              <th class="table-page__actions-head table-page__actions--multi">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let prospecto of listaProspectos">
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ prospecto.razonsocial || 'Sin nombre' }}</strong>
                  <span class="table-page__subtext">Seguimiento comercial</span>
                </div>
              </td>
              <td>
                <span class="table-page__text">{{ prospecto.fechaInicio | date: 'dd/MM/yyyy' }}</span>
              </td>
              <td>
                <span class="table-page__status-badge" [ngClass]="getStatusClass(prospecto)">
                  {{ getStatusLabel(prospecto) }}
                </span>
              </td>
              <td class="table-page__actions table-page__actions--multi">
                <div class="table-page__action-group">
                  <button
                    type="button"
                    class="table-page__action-btn"
                    *ngIf="prospecto.estatus !== 'CERRADO'"
                    (click)="modSegumiento(prospecto)">
                    <i class="material-icons">edit</i>
                  </button>
                  <button type="button" class="table-page__action-btn" (click)="finSeguimiento(prospecto)">
                    <i class="material-icons">local_florist</i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #prospeccionEmptyState>
          <div class="table-page__empty" *ngIf="!loading; else prospeccionLoadingState">
            <i class="material-icons">person_search</i>
            <strong>No se encontraron prospectos</strong>
            <span>Pruebe con otro nombre o registre un nuevo prospecto desde el botón superior.</span>
          </div>
        </ng-template>

        <ng-template #prospeccionLoadingState>
          <div class="table-page__empty table-page__empty--loading">
            <i class="material-icons">hourglass_top</i>
            <strong>Cargando prospectos...</strong>
          </div>
        </ng-template>
      </div>

      <div class="table-page__footer" *ngIf="showPagination">
        <div class="table-page__meta">
          <span>Mostrando {{ rangeEnd }} de {{ totalRegistros }} prospectos</span>
          <span>Página {{ currentPage }} de {{ totalPages || 1 }}</span>

          <label class="table-page__page-size">
            <span>Ver:</span>
            <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
              <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
            </select>
          </label>
        </div>

        <div class="table-page__pager" *ngIf="totalPages > 0">
          <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">
            Inicio
          </button>
          <button type="button" class="table-page__pager-link" (click)="previousPage()" [disabled]="currentPage === 1">
            Anterior
          </button>

          <ng-container *ngFor="let item of getPaginationItems()">
            <button
              *ngIf="isPageNumber(item); else prospeccionPagerEllipsis"
              type="button"
              class="table-page__pager-page"
              [class.is-current]="item === currentPage"
              (click)="onPageChange(item)">
              {{ item }}
            </button>

            <ng-template #prospeccionPagerEllipsis>
              <span class="table-page__pager-ellipsis">...</span>
            </ng-template>
          </ng-container>

          <button type="button" class="table-page__pager-link" (click)="nextPage()" [disabled]="currentPage === totalPages">
            Siguiente
          </button>
          <button type="button" class="table-page__pager-link" (click)="lastPage()" [disabled]="currentPage === totalPages">
            Último
          </button>
        </div>
      </div>
    </section>
  </div>
</div>
